import { RootState } from '../root.reducer';

export const getSmartCoolerProductsState = (state: RootState) => state.smartCoolerProducts;
export const getSmartCoolerProductsList = (state: RootState) => {
    return state.smartCoolerProducts.smartCoolerProducts;
};
export const getSmartCoolerProduct = (state: RootState) => state.smartCoolerProducts.smartCoolerProduct;
export const getSmartCoolerProductsLoading = (state: RootState) => state.smartCoolerProducts.loading;
export const getSmartCoolerProductsError = (state: RootState) => state.smartCoolerProducts.error;
export const getSmartCoolerProductsMessage = (state: RootState) => state.smartCoolerProducts.message;
